import { auth } from '../../firebaseConfig';

/**
 * Authenticated fetch shared by the feedback agent + superadmin BFF calls.
 * Attaches the Firebase ID token, sets JSON content-type when there's a body,
 * throws if there's no signed-in user, and surfaces a useful error on non-2xx.
 * `url` is a full path (relative `/api/...` or absolute).
 */
export async function authFetch(url: string, init?: RequestInit): Promise<any> {
  const token = await auth.currentUser?.getIdToken();
  if (!token) throw new Error('No auth token');
  const res = await fetch(url, {
    ...init,
    headers: {
      ...(init?.headers || {}),
      Authorization: `Bearer ${token}`,
      ...(init?.body ? { 'Content-Type': 'application/json' } : {}),
    },
  });
  const payload = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error((payload && (payload.error || payload.detail)) || res.statusText);
  }
  return payload;
}

// For fetch calls that handle the response themselves; empty when signed out (the route answers 401).
export async function authHeaders(): Promise<Record<string, string>> {
  const token = await auth.currentUser?.getIdToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export default authFetch;
